module.exports = __webpack_public_path__ + "img/logo_18.c7fe3ad3.png";